import styled from "styled-components";

export const JackpotToastLogoDefaultBox = styled.img`
    width: 16rem;
    @media only screen and (max-width: 480px) {
        width: 10rem;
    }
`;
